<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-15 13:39:48
 * @LastEditTime: 2020-11-21 18:44:51
 * @LastEditors: wutt
 -->
<template>
  <div class="divContainer">

    <UCNavBar ref="ucNavBar"></UCNavBar>

    <div class="divMainMap">
      <UCMap ref="ucMainMap"></UCMap>
    </div>

    <UCSideBar ref="ucSideBar"></UCSideBar>
    <div>
      <UCBaseLayerSwitch ref="ucLayerSwitch"></UCBaseLayerSwitch>
    </div>

    <UCZoomControl ref="ucZoomControl"></UCZoomControl>
    <UCCustomMapBottomLeft ref="ucMapBottomLeft"></UCCustomMapBottomLeft>

  </div>
</template>
<script>
import UCMap from "./onlineMap/mainMap/UCMap.vue";
import UCSideBar from "../components/onlineMap/sideBar/UCSideBar.vue";
import UCPOIFuzzyKey from "../components/onlineMap/POISearch/UCPOIFuzzyKey.vue";
import UCMapServiceTree from "./onlineMap/mapService/UCMapServiceTree.vue";
import UCBaseLayerSwitch from "./onlineMap/baseLayerSwitch/UCBaseLayerSwitch.vue";
import UCNavBar from "../components/onlineMap/navbar/UCNavBar.vue";

import UCZoomControl from "../components/onlineMap/UCZoomControl/UCZoomControl.vue";
import UCCustomMapBottomLeft from "../components/onlineMap/customMapControls/UCCustomMapBottomLeft.vue";

import { UCOnlineMapEventManager } from "./onlineMap/UCOnlineMap.js";
import { UCModuleItemType } from "./onlineMap/sideBar/UCSideBarJs.js";
import { SystemConfig } from "../config/SystemConfig.js";

export default {
  name: "onlineMap",
  props: {
    // msg: String
  },
  data() {
    return {
      eventManager: null
    };
  },

  mounted() {
   // this.init();
    this.initEx();// 走底图配置
  },

  beforeCreate() {
    //初始化系统配置
    SystemConfig.getInstance().init();
  },

  methods: {
    initEx() {
      let self = this;
      this._initMapEx(()=>{        
        self.$refs.ucSideBar.curMap = self.$refs.ucMainMap.getMap();
        self.$refs.ucSideBar.init();

        self.$refs.ucNavBar.curMap = self.$refs.ucMainMap.getMap();
        self.$refs.ucNavBar.init();

        self._initEvents();       
      });
    },
     init() {
      this._initMap();
      this.$refs.ucSideBar.curMap = this.$refs.ucMainMap.getMap();
      this.$refs.ucSideBar.init();

      this.$refs.ucNavBar.curMap = this.$refs.ucMainMap.getMap();
      this.$refs.ucNavBar.init();

      this._initEvents();
    },

    _initEvents() {
      this.eventManager = new UCOnlineMapEventManager();
      this.eventManager.ucMap = this.$refs.ucMainMap;
      this.eventManager.ucSideBar = this.$refs.ucSideBar;
      this.eventManager.ucNavBar = this.$refs.ucNavBar;
      this.eventManager.ucLayerSwitch = this.$refs.ucLayerSwitch;
      this.eventManager.ucZoomControl = this.$refs.ucZoomControl;
      this.eventManager.ucMapBottomLeft = this.$refs.ucMapBottomLeft;

      this.eventManager.addListener();
    },

    _initMap() {
      let mapOptions = {
        indoor: false
      };
       this.$refs.ucMainMap.init(mapOptions, false);
    },
    _initMapEx(callback){
       let mapOptions = {
        indoor: false
      };
     this.$refs.ucMainMap.initEx(mapOptions, false,callback);// 根据运维配置获取底图数据
    }
  },
  components: {
    UCMap,
    UCPOIFuzzyKey,
    UCSideBar,
    UCMapServiceTree,
    UCBaseLayerSwitch,
    UCNavBar,
    UCZoomControl,

    UCCustomMapBottomLeft
  },
  created: function() {
    this.$emit("header", 1);
    this.$emit("footer", 3);
  }
};
</script>
<style lang="scss">
.divContainer {
  width: 100%;
  height: 100%;
  position: relative;

  .ucSideBar {
    position: absolute;
    width: 330px;
    height: 90%;
    top: 52px;
    bottom: 0px;
    left: 0px;
    // left: -337px;
    background: #fff;
    border-right: 1px solid #aaa;
    transition: left 0.5s ease;
    z-index: 6;
    box-shadow: 1px 0 5px rgba(0, 0, 0, 0.5);
    border-collapse: separate;
    .show {
      left: -330px;
    }

    .side_bar_stretch {
      position: absolute;
      width: 20px;
      height: 40px;
      background: hsla(0, 0%, 100%, 0.6);
      top: 9px;
      right: -22px;
      border: 1px solid #aaa;
      border-left: none;
      cursor: pointer;
      display: block;
      transition: 0.2s;
    }
  }

  .divMainMap {
    height: 100%;
    width: 100%;
  }
}
</style>
